
<template>
    <div>
        <div class="modal fade" id="modal-lease-back-apartment-client-booking" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header" style="text-align:center">
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4">
                                <div class="form-group">
                                    <div class="input-group date">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar">
                                                <label>
                                                <span
                                                    style="margin-left:5px;display:inline-block;"
                                                >{{$t('service_history.date_from')}}:</span>
                                                </label>
                                            </i>
                                        </div>
                                        <date-picker
                                            :config="options"
                                            :value="checkin_datetime"
                                            v-model="checkin_datetime"
                                        ></date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-md-4 col-lg-4">
                                <div class="form-group">
                                    <div class="input-group date">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar">
                                                <label>
                                                <span
                                                    style="margin-left:5px;display:inline-block;"
                                                >{{$t('service_history.date_to')}}:</span>
                                                </label>
                                            </i>
                                        </div>
                                        <date-picker
                                            :config="options"
                                            :value="checkout_datetime"
                                            v-model="checkout_datetime"
                                        ></date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <button
                                type="button"
                                class="btn btn-labeled btn-warning pull-left"
                                @click="onSearchApartmentClientBooking($event)"
                                >
                                    <span class="btn-label">
                                        <i class="glyphicon glyphicon-search"></i>
                                    </span>
                                    Tìm Kiếm
                                </button>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <lte-button
                                    style="float:right;background-color:white !important;"
                                    type="btn btn-default"
                                    right_icon="fa fa-download"
                                    @click="onExport($event)"
                                >{{$t('customer.export')}}</lte-button>
                            </div>
                        </div>
                        <div>
                            <select-option-check
                                style="margin-top: -20px;"
                                :item="columnsApartment"
                                class="dropdown-trigger"
                                data-icon="eye"
                                @callbackData="onColumnSelect"
                            ></select-option-check>
                        </div>
                    </div>
                    <div class="modal-body">
                        <!-- <b-table sticky-header striped style="white-space: nowrap;" responsive :items="apartmentClientForBookingList" :busy="isLoading" :fields="apartmentClientForBookingFields">
                            <template v-slot:table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
                                </div>
                            </template>
                            <template v-for="index in apartmentClientForBookingFields" :slot="'HEAD_' + index.key" slot-scope="item">
                                {{ $t(item.label) }}
                            </template>
                            <template slot="target" slot-scope="row">
                                <a :href="row.item.url" target="_blank" :id="`apartment_reservation_target_${row.item.id}`">{{row.item.target}}</a>
                                <tooltip :text="row.item.url" :target="`#apartment_reservation_target_${row.item.id}`"/>
                            </template>
                        </b-table> -->
                        <lte-table
                            ref="lte_table"
                            :hdBackground="hdBackground"
                            :data="apartmentClientForBookingList"
                            :columns="apartmentClientForBookingFields"
                            search_filter="left-search"
                            :useFilter="useFilter"
                            :row_mouse_pointer="false"
                            :boxStyle="boxStyle"
                            >
                        </lte-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LTEButton from "@/components/LTEButton.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import LTETable from "@/components/LTETable.vue";
import XLSX from "xlsx";
import utils from '@/lib/utils'
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
export default {
  name: "LeaseBackApartmentBookingList",
  data() {
    return {
        apartmentClientForBookingList: [
        ],
        apartmentClientForBookingFields: [
            { text: 'STT', isHidden: true },
            { text: 'Khách Hàng', isHidden: true },
            { text: 'Phòng', isHidden: true },
            { text: 'CMND/HC', isHidden: true },
            { text: 'Năm Sinh', isHidden: true },
            { text: 'Nam/Nữ', isHidden: true },
            { text: 'Quốc Tịch', isHidden: true },
            { text: 'Ngày Đến', isHidden: true },
            { text: 'Ngày Đi', isHidden: true },
            { text: 'Ghi Chú', isHidden: true }
        ],
        columnsApartment: {
            data_list: [],
            itemType: 1,
            showLabel: false,
            modifyFromPosition: "margin-top:-300px",
            cssClassSm1: "col-md-1",
            cssClassSm2: "col-sm-1",
            showAddNew: false
        },
        useFilter: false,
        boxStyle: false,
        hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
        isLoading: false,
        checkin_datetime: null,
        country_list: [],
        checkout_datetime: null,
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
    }
  },
  watch: {
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
        if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
            let newGridColumns = [];
            const viewedColumnsKey = Object.keys(
            this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
            );
            const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
            .viewed_columns;
            if(this.apartmentClientForBookingFields.length == viewedColumns.length) {
                for (let j = 0, sizeOrigin = this.apartmentClientForBookingFields.length; j < sizeOrigin; j++) {
                    for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
                        if (this.apartmentClientForBookingFields[j].text == viewedColumnsKey[i]) {
                            let viewdColumnObject = {};
                            viewdColumnObject.text = viewedColumnsKey[i];
                            viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
                            newGridColumns.push(viewdColumnObject);
                            break;
                        }
                    }
                }
                this.apartmentClientForBookingFields = newGridColumns;
                this.columnsApartment.data_list = this.apartmentClientForBookingFields;
            } else if(this.apartmentClientForBookingFields.length != viewedColumnsKey.length) {
                let updateGridColumns = []
                for (let i = 0; i < this.apartmentClientForBookingFields.length; i++) {
                    for (let j = 0; j < viewedColumnsKey.length; j++) {
                        if(this.apartmentClientForBookingFields[i] != viewedColumnsKey[j]){  
                        let viewdColumnObject = {};
                        viewdColumnObject.text = this.apartmentClientForBookingFields[i].text;
                        viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[j]];
                        updateGridColumns.push(viewdColumnObject);
                        break;
                        }
                    }              
                }
                this.apartmentClientForBookingFields = updateGridColumns;
                this.columnsApartment.data_list = this.apartmentClientForBookingFields;
            }
            
        }
    }
  },
  computed: {
    ...mapGetters([
        "GET_SNACK_BAR",
        "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ]),
  },
  methods: {
    ...mapActions([
        "SUCCESS_TOAST",
        "ON_SHOW_TOAST",
        "ERROR_TOAST",
        "GET_LEASEBACK_APARTMENT_CLIENT_BOOKING",
        "GET_COUNTRY_LIST",
        "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
        "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
    ]),
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "leasebackapartmentclientbookinglist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchApartmentClientBooking: function() {
        this.getApartmentClientForBooking()
    },
    getCountryName: function(country_id) {
        for (let i = 0, size = this.country_list.length; i < size; i++) {
            if (country_id == this.country_list[i].value) {
                return this.country_list[i].text
            }
        }
    },
    getGender(gender) {
        if (gender == 1) {
            return this.$t('customer.gender_type[0]');
        } else if (gender == 2) {
            return this.$t('customer.gender_type[1]');
        } else {
            return this.$t('customer.gender_type[2]');
        }
    },
    formatDateTime: function(dateTime, fromFormat, toFormat) {
        if (!utils.isNull(dateTime)) {
            return utils.formatDateTime(dateTime, fromFormat, toFormat)
        }
    },
    getApartmentClientForBooking: function() {
        let data = {
            params: {
                checkin_datetime: this.checkin_datetime,
                checkout_datetime: this.checkout_datetime
            }
        }
        this.isLoading = true
        this.GET_COUNTRY_LIST().then(
            function(res) {
                let countries = [];
                let dataCountries = res.data;
                dataCountries.forEach(c => {
                    let country = {
                        value: c.id,
                        text: c.country_name
                    }
                    countries.push(country);
                })
                this.country_list = countries;
                this.GET_LEASEBACK_APARTMENT_CLIENT_BOOKING(data).then(
                    function(res) {
                        let data = res
                        this.apartmentClientForBookingList = []
                        let stt = 0
                        let checkout_expected_datetime = null
                        for (let i = 0, size = data.length; i < size; i++) {
                            let fullName = ''
                            let country = ''
                            let gender = ''
                            let dob = ''
                            let otherDetails = ''
                            let passport = ''
                            let checkin_datetime = null
                            let checkout_datetime = null
                            checkout_expected_datetime = utils.formatDateTime(data[i].checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
                            for (let j = 0, ids = data[i].apartment_lease_back_clients_ids.length; j < ids; j++) {
                                // No
                                stt += 1
                                // Get full name
                                fullName = data[i].apartment_lease_back_clients_ids[j].client_details.full_name && data[i].apartment_lease_back_clients_ids[j].client_details.full_name
                                // Get country id and convert to country name
                                country = data[i].apartment_lease_back_clients_ids[j].client_details.country && data[i].apartment_lease_back_clients_ids[j].client_details.country
                                // Get gender id and convert to gender name
                                gender = data[i].apartment_lease_back_clients_ids[j].client_details.gender && data[i].apartment_lease_back_clients_ids[j].client_details.gender
                                // Get dob
                                dob = !utils.isNull(data[i].apartment_lease_back_clients_ids[j].client_details.dob) ? utils.formatDateTime(data[i].apartment_lease_back_clients_ids[j].client_details.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null
                                // Get other details
                                otherDetails = data[i].apartment_lease_back_clients_ids[j].client_details.other_details && data[i].apartment_lease_back_clients_ids[j].client_details.other_details
                                // Get passport
                                passport = data[i].apartment_lease_back_clients_ids[j].client_details.id_passsport && data[i].apartment_lease_back_clients_ids[j].client_details.id_passsport
                                // Check-in date time
                                checkin_datetime = data[i].apartment_lease_back_clients_ids[j].client_details.checkin_datetime
                                checkin_datetime = !utils.isNull(checkin_datetime) ? utils.formatDateTime(checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null
                                // Check-out date time
                                checkout_datetime = data[i].apartment_lease_back_clients_ids[j].client_details.checkout_datetime
                                checkout_datetime = !utils.isNull(checkout_datetime) ? utils.formatDateTime(checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null
                                let object = {
                                    'STT': stt,
                                    'Khách Hàng': fullName,
                                    'Phòng': data[i].apartment_mapping_with_booking_ids[0].apartment_details.apartment_code,
                                    'CMND/HC': passport,
                                    'Năm Sinh': dob,
                                    'Nam/Nữ': (!utils.isNull(country) && country != '') ? this.getGender(gender) : '',
                                    'Quốc Tịch': (!utils.isNull(country) && country != '') ? this.getCountryName(country) : '',
                                    'Ngày Đến': checkin_datetime,
                                    'Ngày Đi': checkout_expected_datetime,
                                    'Ghi Chú': otherDetails
                                }
                                this.apartmentClientForBookingList.push(object)
                            }
                        }
                        this.isLoading = false
                    }.bind(this)
                ).catch(
                    function(error) {
                        this.isLoading = false
                    }.bind(this)
                )
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
            }.bind(this)
        )
    },
    onShowModal(checkin_datetime, checkout_datetime) {
        this.checkin_datetime = checkin_datetime
        this.checkout_datetime = checkout_datetime
        $("#modal-lease-back-apartment-client-booking").modal("show")
        this.getApartmentClientForBooking()
    },
    onExport: async function() {
        var apartmentClientBooking = XLSX.utils.json_to_sheet(this.apartmentClientForBookingList);
        var wscols = [
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20}
        ];
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, apartmentClientBooking, "apartmentClientBooking");
        apartmentClientBooking['!cols'] = wscols;
        for (let i = 0, size = this.apartmentClientForBookingFields.length; i < size; i++) {
            if (!this.apartmentClientForBookingFields[i].isHidden) {
                apartmentClientBooking['!cols'][i] = { hidden: true };
            }
        }
        // export Excel file
        XLSX.writeFile(wb, `LeaseBackClientBookingList` + '_' + `${this.checkin_datetime}` + '_' + `${this.checkout_datetime}.xlsx`); // name of the file is 'book.xlsx'
    },
  },
  mounted() {
    this.columnsApartment.data_list = this.apartmentClientForBookingFields;
    const filter = {
      params: {
        tablename: "leasebackapartmentclientbookinglist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
  },
  components: {
    "lte-button": LTEButton,
    "date-picker": datePicker,
    "lte-table": LTETable,
    "select-option-check": SelectOptionCheck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentClientBookingList.vue